import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input  } from '@angular/core';
import { ForeclosureAuction } from '../models/ForeclosureAuction';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ManageForeclosureAuctionService } from '../manage-foreclosure-auction.service';
import { ForeclosureAuctionSearchParams } from '../models/ForeclosureAuction'

@Component({
  selector: 'app-edit-foreclosure-auction',
  templateUrl: './edit-foreclosure-auction.component.html',
  styleUrls: ['./edit-foreclosure-auction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditForeclosureAuctionComponent implements OnInit {
  @Output() cancelEditEvent = new EventEmitter<boolean>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() objMessage = new EventEmitter<{}>();
  @Output() reload = new EventEmitter<boolean>();
  @Input() currentRecord : ForeclosureAuction

  public editForeclosureAuctionForm: FormGroup = new FormGroup({
    PropertyStates: new FormControl('', [Validators.required]),
    County: new FormControl('', [Validators.required]),
    AuctionLocationAddress: new FormControl('', [Validators.required,  Validators.pattern(/^[^\@$!*%]*$/)]),
    AuctionLocationDetails: new FormControl('', null),
    StatutaryLocation: new FormControl('', null)
  });
  stateControl = this.editForeclosureAuctionForm.get('PropertyStates');
  countyControl = this.editForeclosureAuctionForm.get('County');
  auctionlocationAddress = this.editForeclosureAuctionForm.get('AuctionLocationAddress');
  auctionLocationDetailsControl = this.editForeclosureAuctionForm.get('AuctionLocationDetails');
  statutaryLocationControl = this.editForeclosureAuctionForm.get('StatutaryLocation');
 
  statePlaceholder = "Select One";
  countyPlaceHolder:string ;
  selectedAuctionAddress: string;
  selectedAuctionLocationDetails: string;
  processing: boolean;
  staturtaryValue = 0;
  states: any[];
  county:any[];
  selectedCounty:any;
  selectedState: any;
  params: ForeclosureAuctionSearchParams;
  loading: boolean;
  loadingCounting: boolean;
  countyLoaded: boolean;

  constructor(private manageForeclosureAuctionService : ManageForeclosureAuctionService) { }

  ngOnInit() {
    this.getAllStates();
    this.staturtaryValue = this.currentRecord.StatutaryLocation ? 1 : 0;
    this.selectedAuctionAddress = this.currentRecord.AuctionLocationAddress;
    this.selectedAuctionLocationDetails = this.currentRecord.AuctionLocationDetails;
  }

  
  getAllStates(): any {
  //  this.statePlaceholder = "Loading..";
    this.states = [{'label': 'Loading..', 'value': 'Loading..'}]
    this.county = [{'label': 'Loading..', 'value': 'Loading..'}];
    this.manageForeclosureAuctionService.getStates()
      .subscribe((statesData: any) => {
        this.states = statesData.filter((objState) => {
          return objState.StateCode !== 'ALL';
        });
        this.selectedState = this.states.find(x => x.label === this.currentRecord.State);
        this.selectCounty();
      }
      , (error) => {
        this.objMessage.emit({ 'severity': 'error', 'message': 'Couldnot load states' });
        throw new Error('Could not load states.');
      });
  }

  selectCounty() : void {
    this.manageForeclosureAuctionService.getCounty(this.selectedState.value.toString()).subscribe(res => {
      this.county = res.data;
      this.selectedCounty = this.county.find(x => x.label === this.currentRecord.County);
    })
  }

  populateCounty(): void {
    this.selectedCounty = ''; 
    this.countyPlaceHolder = 'Select One';
    this.manageForeclosureAuctionService.getCounty(this.selectedState.value.toString()).subscribe(res => {
      this.county = res.data;
    })
  }

  hideEditForeclosureAuctionForm(): void {
    this.reload.emit(false);
    this.cancelEditEvent.emit(false);
    this.setBreadCrumbs.emit([{ label: 'Manage Foreclosure Auction location' }]);
  }

  submitEditForeclosureAuctionForm():void{
    this.params = <ForeclosureAuctionSearchParams>{};
    this.processing = true;
    this.params = {
      State : this.stateControl.value.value, 
      County : this.countyControl.value.value,
      StatutaryLocation: this.statutaryLocationControl.value,
      LocationAddress: this.auctionlocationAddress.value,
      LocationDetails: this.auctionLocationDetailsControl.value,
      FcMatrixID: this.currentRecord.FcMatrixID
    }

    this.manageForeclosureAuctionService.update(this.params).subscribe(res => {
      this.processing = false; 
      if(!res.error && res.data.length >0){
        this.objMessage.emit({'severity': 'success', 'detail': 'Foreclosure Auction location Edited successfully.'});
        this.cancelEditEvent.emit(false);
        this.setBreadCrumbs.emit([{ label: 'Manage Foreclosure Auction Location' }]);
      }else if(res.error && res.data.length == 0){
        this.objMessage.emit({'severity': 'error', 'detail': res.messages[0]});
      }
    }, error => {
      this.processing = false;   
      this.objMessage.emit({'severity': 'error', 'detail': error.message});  
    })
  }

}
